import React from 'react';
import { CHECKOUT_MESSAGES } from '../../constants/checkout';

/** Bloco de confiança no checkout: foto da idealizadora + marca Constela Brasil. */
const CheckoutFounderTrust: React.FC = () => {
  const { founder } = CHECKOUT_MESSAGES;

  return (
    <section
      className="mb-6 w-full max-w-full rounded-2xl border border-[#D8D1F0] bg-gradient-to-br from-[#F7F4FF] via-white to-[#EAF4F2] shadow-sm"
      aria-label={founder.sectionLabel}
    >
      <div className="h-1 w-full bg-gradient-to-r from-[#4A7C75] via-[#5C528A] to-[#8B7BB8]" aria-hidden />

      <div className="p-4 sm:p-5">
        <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:items-start sm:text-left">
          <div className="relative shrink-0">
            <div
              className="rounded-2xl bg-gradient-to-br from-[#5C528A] via-[#7A6F9E] to-[#4A7C75] p-[3px] shadow-md"
              aria-hidden
            >
              <div className="overflow-hidden rounded-[13px] bg-white">
                <img
                  src="/assets/checkout/erica-coscioni.png"
                  alt={founder.photoAlt}
                  className="h-[88px] w-[72px] object-cover object-[center_20%] sm:h-[96px] sm:w-[78px]"
                  width={78}
                  height={96}
                />
              </div>
            </div>
          </div>

          <div className="min-w-0 flex-1 pt-0.5">
            <img
              src="/assets/constela.png"
              alt="Constela Brasil"
              className="mx-auto mb-2 h-7 w-auto max-w-[140px] object-contain sm:mx-0 sm:object-left"
            />
            <p className="text-base font-semibold leading-tight text-gray-900">{founder.name}</p>
            <p className="mt-0.5 text-sm font-medium text-[#5C528A]">{founder.role}</p>
            <p className="mt-2 text-xs leading-relaxed text-gray-600 sm:text-sm">{founder.tagline}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CheckoutFounderTrust;

